import {
  ACTIVE_INDEX,
  PATIENT_ID,
  REQUEST_ID,
  UPCOMING_ID,
  PENDING_ID,
  SELECT_PLAN,
} from 'store/BasicDetailValues/BasicDetailValuesAction';

const initialState = {
  activeIndex: 0,
  patientId: '',
  requestId: '',
  upcomingId: '',
  pendingId: '',
  selectPlan: [],
};

const basicDetailsValueReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIVE_INDEX:
      return {
        ...state,
        activeIndex: action.payload,
      };
    case PATIENT_ID:
      return {
        ...state,
        patientId: action.payload,
      };
    case REQUEST_ID:
      return {
        ...state,
        requestId: action.payload,
      };
    case UPCOMING_ID:
      return {
        ...state,
        upcomingId: action.payload,
      };
    case PENDING_ID:
      return {
        ...state,
        pendingId: action.payload,
      };
    case SELECT_PLAN:
      return {
        ...state,
        selectPlan: action.payload,
      };
    default:
      return state;
  }
};

export default basicDetailsValueReducer;
